import { Breadcrumbs } from '../models/breadcrumbs.models';

export interface BreadcrumbsState {
    breadcrumbs: Breadcrumbs;
}

export const BreadcrumbsInitialState: BreadcrumbsState = {
    breadcrumbs: [],
};
